<template>
  <div class="pt132 cart-item-wrap-menu">
    <div class="mb12 pl8" v-if="selectedCategory">
      <div class="fs-16 section-header-menu bold">
        {{ selectedCategory }} ({{ getCountProduct(getCategoryNodeId) }})
      </div>
    </div>
    <div
      class="cards-holder-menu"
      v-if="getOneCategoryProductItems(getCategoryNodeId)?.length"
    >
      <hongs-product-card
        v-for="(value, index) in getOneCategoryProductItems(getCategoryNodeId)"
        :key="index"
        :data-item="value"
        :data-item-index="index"
        :data-cardRounded="productCardProps.cardRounded"
        :data-smallCards="productCardProps.smallCards"
        :data-hideImage="productCardProps.hideImage"
        :showFullInfo="true"
        :data-counterText="getCategoryNodeId"
        :data-categoryId="getCategoryNodeId"
      ></hongs-product-card>
    </div>
    <div
      v-else-if="getSubCategoryItems(getCategoryNodeId)?.length"
      v-for="(item, index) in getSubCategoryItems(getCategoryNodeId)"
      :key="index"
    >
      <h3
        class="card-catg-name pt5"
        :class="{
          subCategory: item.isSubCategory,
        }"
        v-if="getOneCategoryProductItems(item?.nodeId)?.length > 0"
      >
        {{ item?.nodeName?.split("_").join(" ") }}
        <span v-if="getOneCategoryProductItems(item?.nodeId)?.length > 0"
          >({{ getOneCategoryProductItems(item?.nodeId).length }})</span
        >
      </h3>
      <div class="cards-holder-menu">
        <hongs-product-card
          v-for="(value, subIndex) in getOneCategoryProductItems(item?.nodeId)"
          :key="subIndex"
          :data-item="value"
          :data-item-index="subIndex"
          :data-cardRounded="productCardProps.cardRounded"
          :data-smallCards="productCardProps.smallCards"
          :data-hideImage="productCardProps.hideImage"
          :showFullInfo="true"
          :data-counterText="item?.nodeId"
          :data-categoryId="item?.nodeId"
        ></hongs-product-card>
      </div>
    </div>
    <div v-else class="empty-cart">
      <div class="tc">
        <img :src="staticImgBaseUrl + '/images/global/img-empty-cart.svg'" />
      </div>
      <div class="fs-14 title lh21 tc">Oops! No such item present</div>
    </div>
    <!-- item add/remove toast msg -->
    <toast-msg
      v-if="showItemToastMsg"
      :data-img="staticImgBaseUrl + '/images/global/itemToastIcon.svg'"
      :data-text="itemToastMsg"
      :data-style="'item-toast-msg'"
      :data-text-color="'textWhite'"
    ></toast-msg>
  </div>
</template>

<script>
import HongsProductCard from "./HongsProductCard.vue";
import Utility from "../helpers/utility";
import {
  keyMapsAction,
  keyMapsMutation,
  keyMapsGetter,
} from "../helpers/storeKeys";
import { staticImgBaseUrl, showItemToast } from "../config/apiEndpoints";
import LocalStorageFunc from "../helpers/localStorageFunc";
import { defineAsyncComponent } from "vue";
import { setEvents } from "../helpers/analyticsEvents";

export default {
  name: "VerticalProductsScrollMenu",
  components: {
    HongsProductCard,
    ToastMsg: defineAsyncComponent(() => import("./ToastMsg.vue")),
  },
  props: ["dataResults", "moduleProps"],
  data() {
    return {
      productCardProps: {
        cardRounded: true,
        smallCards: false,
        hideImage: false,
      },
      staticImgBaseUrl,
      isEventLogged: true,
    };
  },
  mounted() {
    this.modulePropsParsed = JSON.parse(this.moduleProps);
    this.loadData = Utility.tryJsonParse(this.dataResults, []);
    this.processResultDataForStore(this.loadData);
    if (LocalStorageFunc.isLoggedIn()) {
      this.$store.dispatch(keyMapsAction.GET_FAVOURITE_IDS_API, {});
    } else {
      this.$store.commit(
        keyMapsMutation.MARK_FAVOURITE_IDS,
        LocalStorageFunc.getFavouriteIds()
      );
    }
    // let queryParams = Utility.getQueryFromUrl();
    // if (queryParams["category"]) {
    //   this.$store.commit(
    //     keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
    //     queryParams["category"]?.split("+").join(" ")
    //   );
    //   this.$store.commit(
    //     keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
    //     queryParams["category"]?.split("+").join(" ")
    //   );
    // }
    setTimeout(
      () => document.body.classList.remove("body-stop-scroll-mobile"),
      3500
    );
  },
  methods: {
    processResultDataForStore(data) {
      this.$store.commit(keyMapsMutation.UPDATE_PRODUCTS_IN_STORE, data);
      this.$store.commit(keyMapsMutation.LOAD_CART_FROM_STORAGE_SERVICE, data);
      this.$store.commit(
        keyMapsMutation.UPDATE_IMG_BASE_URL,
        data?.mediaBaseURL
      );
    },
    getOneCategoryProductItems(categoryId) {
      const oneCategoryProductItems =
        this.$store.getters[keyMapsGetter.GET_PRODUCTS][categoryId];

      if (
        oneCategoryProductItems &&
        Object.keys(oneCategoryProductItems).length &&
        this.isEventLogged
      ) {
        this.isEventLogged = false;
        setEvents("meta", "FB_ViewContent", {});
      }

      const products = this.$store.state.ProductItems.productCategory.find(
        (x) => x.nodeId === categoryId
      )?.children;

      if (!products) return [];
      const filteredProducts = products
        .map((product) => oneCategoryProductItems[product?.skuId])
        .filter(Boolean);

      return filteredProducts;
    },
    getSubCategoryItems(categoryId) {
      return this.$store.state.ProductItems.productCategory.filter(
        (x) => x.parentNodeId === categoryId
      );
    },
    getCountProduct(getCategoryNodeId) {
      let count =
        this.getOneCategoryProductItems(getCategoryNodeId)?.length ||
        this.getSubCategoryItems(getCategoryNodeId).reduce((total, item) => {
          const products = this.getOneCategoryProductItems(item?.nodeId);
          return total + products?.length;
        }, 0);
      if (!count) {
        this.$store.commit(
          keyMapsMutation.SET_PRODUCT_COUNTER_STRING,
          this.productCategory?.[0]?.nodeName
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_STOP_HORIZONTAL_SCROLL_ANCHOR_LINKS,
          true
        );
        this.$store.commit(
          keyMapsMutation.UPDATE_CLICKED_CATEGORY_ANCHOR_LINK,
          this.productCategory?.[0]?.nodeName
        );
        let scrollTopMargin = window.screen.width <= 321 ? 70 : 102;

        Utility.scrollUptoTo(
          "element_catg_" + this.productCategory?.[0]?.nodeId,
          scrollTopMargin
        );
      }
      return count;
    },
  },
  computed: {
    selectedCategory() {
      return (
        this.$store.state.Menu.clickedCategoryAnchorLink ||
        (this.$store.state.ProductItems.productCategory.length &&
          this.$store.state.ProductItems.productCategory[0]?.nodeName)
      );
    },
    // productCategories() {
    //   let pCategories = this.$store.state.ProductItems.productCategory;

    //   if (!pCategories?.length) {
    //     let pMapShort = this.$store.state.ProductItems.productCategoryMapShort;
    //     return Object.keys(pMapShort).map((key) => {
    //       return { nodeId: key, nodeName: pMapShort[key] };
    //     });
    //   }
    //   return pCategories;
    // },
    getCategoryNodeId() {
      return (
        this.$store.state.ProductItems.productCategory?.length &&
        this.$store.state.ProductItems.productCategory.find(
          (x) => x.nodeName === this.selectedCategory
        ).nodeId
      );
    },
    productCategory() {
      return this.$store.state.ProductItems.productCategory;
    },
    itemToastMsg() {
      return this.$store.state.Cart.itemToastMsg;
    },
    showItemToastMsg() {
      return this.$store.state.Cart.showItemToastMsg && showItemToast;
    },
  },
};
</script>

<style></style>
